import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  viewEntry(options, data) {
    const response = Api().post(apiPath.viewEntry, data, options);
    return response;
  },

  getEntry(options, data) {
    const response = Api().post(apiPath.getEntry, data, options);
    return response;
  },

  changeStatus(options, data) {
    const response = Api().post(apiPath.changeStatus, data, options);
    return response;
  },

  changeTopStatus(options, data) {
    const response = Api().post(apiPath.changeTopStatus, data, options);
    return response;
  },

  changeSubStatus(options, data) {
    const response = Api().post(apiPath.changeSubStatus, data, options);
    return response;
  },

  getMenusList(options, data) {
    const response = Api().post(apiPath.menusList, data, options);
    return response;
  },

  createSubmenu(options, data) {
    const response = Api().post(apiPath.createSubmenu, data, options);
    return response;
  },

  editSubmenu(options, data) {
    const response = Api().post(apiPath.editSubmenu, data, options);
    return response;
  },

  createTopmenu(options, data) {
    const response = Api().post(apiPath.createTopmenu, data, options);
    return response;
  },

  editTopmenu(options, data) {
    const response = Api().post(apiPath.editTopmenu, data, options);
    return response;
  },

  //Article
  createArticle(options, data) {
    const response = Api().post(apiPath.createArticle, data, options);
    return response;
  },

  editArticle(options, data) {
    const response = Api().post(apiPath.editArticle, data, options);
    return response;
  },

  //Branch
  createBranch(options, data) {
    const response = Api().post(apiPath.createBranch, data, options);
    return response;
  },

  editBranch(options, data) {
    const response = Api().post(apiPath.editBranch, data, options);
    return response;
  },

  //CardInfo
  createCard(options, data) {
    const response = Api().post(apiPath.createCard, data, options);
    return response;
  },

  editCard(options, data) {
    const response = Api().post(apiPath.editCard, data, options);
    return response;
  }
};
